/** Sort function for wallboxes, so they are sorted consistently in e-mobility graph's bars, legend and tooltip. */
export const wallboxesSort = <T extends { deviceName: string }>(wallboxA: T, wallboxB: T): number => {
  return wallboxA.deviceName.localeCompare(wallboxB.deviceName)
}
